import classNames from 'classnames/bind';
import { isMobile } from 'react-device-detect';
import { Link, useNavigate } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loading from '~/components/Loading';
import GameIcon from '~/components/GameIcon';
import styles from './MobileAward.module.scss';
import Membership from '~/components/Mobile/Membership';
import { dispatchPostError } from '~/redux/reducer/error';
import { convertCurrency, convertDiamond } from '~/configs';
import { logoutAccountSuccess } from '~/redux/reducer/auth';
import { requestPlayerGetAwards } from '~/services/payment';
import { actionSelectAward } from '~/redux/reducer/payment';

const cx = classNames.bind(styles);

function MobileAward() {
    const [awards, setAwards] = useState([]);
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { currentUser } = useSelector((state) => state.auth);
    const { paymentSelected } = useSelector((state) => state.payment);

    useEffect(() => {
        if (!isMobile) {
            navigate('/app');
        } else {
            if (currentUser && currentUser.app) {
                const fetch = async () => {
                    setLoading(true);

                    const result = await requestPlayerGetAwards(currentUser.app.code);

                    setLoading(false);
                    if (result.status === 403) {
                        dispatch(logoutAccountSuccess());
                        localStorage.removeItem('_re');
                        navigate('/');
                        window.location.reload();
                    } else if (result.status === 401) {
                        dispatch(dispatchPostError(result));
                    } else if (result.status === 200) {
                        setAwards(result.data.awards);
                        setMembers(result.data.members);
                    } else {
                        navigate('/app');
                    }
                };
                fetch();
            } else {
                navigate('/app');
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectAward = (award) => {
        dispatch(actionSelectAward({ type: 'award', ...award }));
    };

    return (
        <div className={cx('wrapper')}>
            <Fragment>
                <GameIcon title={paymentSelected.title} />
                <div className={cx('help')}>Chọn gói cần nạp</div>
            </Fragment>

            {loading ? (
                <Loading height="50" />
            ) : (
                <Fragment>
                    <ul className={cx('list')}>
                        {awards.map((award, index) => (
                            <li className={cx('item')} onClick={() => handleSelectAward(award)} key={index}>
                                <Link to={`/app/${currentUser.app.code}/payment`}>
                                    <div className={cx('value')}>
                                        <div className={cx('icon-diamond')}>
                                            <img src={currentUser.app.bonus_icon} alt={currentUser.app.title} />
                                        </div>
                                        <div className={cx('diamond')}>
                                            <div className={cx('diamond-title')}>{award.title}</div>
                                            <div className={cx('diamond-value')}>{convertDiamond(award.value)}</div>
                                        </div>
                                    </div>
                                    <div className={cx('face-value')}>{convertCurrency(award.amount.value)}</div>
                                </Link>
                            </li>
                        ))}
                    </ul>

                    <Membership data={members} refs="/app" />
                </Fragment>
            )}
        </div>
    );
}

export default MobileAward;
